<template>
  <div>
    <commonHeader ref="headerRef" v-if="num == 0" @openProjectTable="openProjectTable" />
    <commonTable v-if="num == 0" :columns="columns" :tableData="tableData" :pagination="pagination" :loading="loading"
      :chooseType="chooseType" @openTable="openTable" @backProject="backProject" @pageChange="pageChange" />
    <basePublicize v-if="num == 1" @backProject="backProject" @goProject="goProject" />
  </div>
</template>

<script>
import commonHeader from "@/components/common-header/index.vue";
import commonTable from "@/components/common-table/index.vue";
import basePublicize from "@/components/base-publicize/index.vue";
import { getPublicizeListApi } from "@/api/declare";
export default {
  components: { commonHeader, commonTable, basePublicize },
  data() {
    return {
      chooseType: 0,
      page: 0,
      num: 0 /* 0为默认，1为打开申请表 */,
      tableData: [],
      pagination: {},
      loading: false,
      pagination: {},
      columns: [
        {
          title: "序号",
          dataIndex: "sort",
          key: "sort",
          width: 100,
        },
        {
          title: "基地名称",
          dataIndex: "baseName",
          key: "baseName",
        },
        {
          title: "基地负责人",
          dataIndex: "linkMan",
          key: "linkMan",
        },
        {
          title: "联系方式",
          dataIndex: "linkPhone",
          key: "linkPhone",
        },
        {
          title: "申报时间",
          dataIndex: "createAt",
          key: "createAt",
          scopedSlots: { customRender: "createAt" },
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "auditOperation",
          key: "auditOperation",
          scopedSlots: { customRender: "auditOperation" },
        },
      ],
    };
  },
  methods: {
    cancelConfirm() {
      this.num = 0;
    },
    nextPage() {
      this.num = 2;
    },
    goProject(val) {
      // console.log(111111);
      this.num = 0;
      setTimeout(() => {
        // console.log(val);
        // console.log(this.$refs);
        this.$refs.headerRef.checkIndex = val;
      }, 500);
      this.getPublicizeList();
    },

    pageChange(val) {
      console.log(val);
      this.page = val.current - 1;
      this.getPublicizeList();
    },
    changeTable(val) {
      this.year = val;
      this.getPublicizeList();
    },
    openTable() {
      this.num = 1;
    },
    backProject() {
      this.num = 0;
      this.getPublicizeList();
    },
    getPublicizeList() {
      this.loading = true;
      let obj = JSON.parse(localStorage.getItem("userModel"));
      let params = {
        type: 3,
        page: this.page,
        pageSize: 10,
        decEntrance: obj.decEntrance,
      };
      if (obj.decEntrance == '部属、省属高校') {
        params.secondaryDecEntrance = obj.productUserId
      };
      getPublicizeListApi(params).then((res) => {
        this.loading = false;
        if (res.status) {
          res.data.forEach((item, index) => {
            item.sort = index + 1;
            let obj = JSON.parse(item.extraInfo)
            // console.log(obj.cityTotal);
            item.cityTotal = obj.cityTotal
          });
          this.tableData = res.data;
          this.pagination = res.pagination;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    openProjectTable() {
      this.num = 1;
    },
  },
  created() {
    setTimeout(() => {
      console.log(this.$refs);
      this.getPublicizeList();
    }, 500);
  },
};
</script>

<style></style>
